import gql from 'graphql-tag'

export const WHATS_ON_FILTERS_QUERY = gql`
  query WhatsOnFiltersCentre($centreId: String!) {
    cfCentre(id: $centreId) {
      linkedFrom {
        whatsHappeningFiltersCollection(limit: 1) {
          items {
            backendTitle
            topicFiltersCollection(limit: 20) {
              items {
                title
              }
            }
            experienceFiltersCollection(limit: 20) {
              items {
                title
              }
            }
          }
        }
      }
    }
  }
`
